import { r7eBaseApp, R7eAccountTypeError, R7E_IApplication, DEBUG_MODE, R7E_NavBarData, R7E_HomeItem } from '@r7e/shared';
import {fake_value} from './fake_data';

class R7E_AuthorApplication extends R7E_IApplication {
    constructor(app) {
        super('author', app)
    }

    // --- NavBar Setup ---

    getNavBarData() {
        const nav = new R7E_NavBarData(this, 'navbar_author.author');
        nav.setItemsBuilder((curr) => {
            const app = curr.app;
            const b = app.base.hasAccessToCurrentService();
            const isAuth = app.isAuthenticated();
            const username = isAuth ? app.getUsername() : null;
            const items = [
                // { route: "/info", title_id: 'navbar_author.authorInfo', condition: b },
                { route: "/authors", title_id: 'navbar_author.authors', description: 'navbar_author.authorsDescription', icon: 'fa-solid fa-users', condition: true },
                { route: "/contents", title_id: 'navbar_author.contents', description: 'navbar_author.contentsDescription', icon: 'fa-solid fa-list', condition: b },                
            ];
            if (isAuth && username) {
                items.unshift({ route: `/author/${username}`, title_id: 'navbar_author.myPage', description: 'navbar_author.myPageDescription', icon: 'fa-solid fa-house-user', condition: true });
            }
            return items;
        });
        return nav;
      }
    // --- end of NavBar Setup ---

    getHomeItems() {
        const row1 = [];
       
        const contents = new R7E_HomeItem(this, 'home_author.contents', 'home_author.contentsDescription', '/contents');
        contents.setIcon('fa-solid fa-list');
        contents.setCSSClass('box-contents');
        contents.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        row1.push(contents);

        // const claims = new R7E_HomeItem(this, 'home_author.claims', 'home_author.claimsDescription', '/resource-claiming');
        // claims.setIcon('fa-solid fa-handshake');
        // claims.setCSSClass('box-claims');
        // claims.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        // lst.push(claims);

        const accountInfo = new R7E_HomeItem(this, 'home_author.myAccount', 'home_author.myAccountDescription', '/account');
        accountInfo.setIcon('fa-solid fa-user');
        accountInfo.setCSSClass('box-account-info');
        accountInfo.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        row1.push(accountInfo); 

        const row2 = [];

        const authorPage = new R7E_HomeItem(this, 'home_author.myPage', 'home_author.myPageDescription', '/author/' + this.getUsername()	);
        authorPage.setIcon('fa-solid fa-user');
        authorPage.setCSSClass('box-author-page');
        authorPage.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        row2.push(authorPage);        

        const allAuthorsPage = new R7E_HomeItem(this, 'home_author.authors', 'home_author.authorsDescription', '/authors');
        allAuthorsPage.setIcon('fa-solid fa-users');
        allAuthorsPage.setCSSClass('box-all-authors');
        // allAuthorsPage.setCondition(true);
        row2.push(allAuthorsPage);        

        return [row1, row2];
    } 

    getAvailableExperimentations() {
        const availableExperimentations = super.getAvailableExperimentations();
        availableExperimentations.push('content-analytics', 'geographic-distribution', 'transactions');
        return availableExperimentations; 
    }
    
    getProfileFieldsSettings() {
        const profile_fields = super.getProfileFieldsSettings();
        // Insert before the entry with key = 'emails'
        const areaOfInterest = {
            key: 'area_of_interest',
            label: 'areaOfInterest',
            type: 'text',
            required: false
        }
        // const idx = profile_fields.findIndex(field => field.key === 'emails');
        // if (idx !== -1) {
        //     profile_fields.splice(idx, 0, areaOfInterest);
        // } else {
        //     profile_fields.unshift(areaOfInterest);
        // }
        const idx = profile_fields.findIndex(field => field.key === 'affiliation');
        if (idx !== -1) {
            profile_fields.splice(idx + 1, 0, areaOfInterest);
        } else {
            profile_fields.push(areaOfInterest);
        }        

        profile_fields.push(
            { key: 'orcid', label: 'orcid', type: 'text', required: false,
              validation: (value) => {
                // ORCID ID format: XXXX-XXXX-XXXX-XXXX (4 groups of 4 digits/letters)
                const orcidPattern = /^\d{4}-\d{4}-\d{4}-\d{3}[\dX]$/;
                return orcidPattern.test(value);
              },
              errorLabel: 'invalidOrcidId'
             }
            )
        profile_fields.push(
            { key: 'linkedin', label: 'linkedin', type: 'url', required: false,
              validation: (value) => {
                return this.isValidUrl(value);
              },
              errorLabel: 'invalidLinkedin'
            }
        )
        profile_fields.push(
            { key: 'google_scholar', label: 'googleScholar', type: 'text', required: false }
        )
        return profile_fields;
    }    

    setupPages() { return super.setupPages().concat(["/resource-claiming"]); }

    // --- Cache Management ---
    getTrafficCache() {
        return this.base.getCacheManager().getCache('traffic_cache');
    }
    getRIndexCache() {
        return this.base.getCacheManager().getCache('rindex_cache');
    }
    getRIndexCacheKey(authorId, params) {
        const { start_date, end_date, top_contents_limit } = params;
        const keyParts = [
            authorId,
            start_date || '',
            end_date || '',
            top_contents_limit != null ? String(top_contents_limit) : ''
        ];
        return `${keyParts.join('_')}`;
    }
    getRIndexCacheData(authorId, params) {
        const cacheKey = this.getRIndexCacheKey(authorId, params);
        return this.getRIndexCache().getCachedData(cacheKey);
    }
    setRIndexCacheData(authorId, params, data) {
        const cacheKey = this.getRIndexCacheKey(authorId, params);
        return this.getRIndexCache().setCachedData(cacheKey, data);
    }
    clearRIndexCacheData(authorId, params) {
        const cacheKey = this.getRIndexCacheKey(authorId, params);
        return this.getRIndexCache().clearCache(cacheKey);
    }
    getTrafficCacheKey(authorId, name, params) {
        const { start_date, end_date, top_contents_limit = 0 } = params;
        const keyParts = [
            name,
            authorId,
            start_date || '',
            end_date || ''
        ];
        if (top_contents_limit !== undefined) {
            keyParts.push(top_contents_limit.toString());
        }
        return `${keyParts.join('_')}`;
    }
    getTrafficCacheData(authorId, name, params) {
        const cacheKey = this.getTrafficCacheKey(authorId, name, params);
        return this.getTrafficCache().getCachedData(cacheKey);
    }
    setTrafficCacheData(authorId, name, params, data) {
        const cacheKey = this.getTrafficCacheKey(authorId, name, params);
        return this.getTrafficCache().setCachedData(cacheKey, data);
    }
    clearTrafficCacheData(authorId, name, params) {
        const cacheKey = this.getTrafficCacheKey(authorId, name, params);
        return this.getTrafficCache().clearCache(cacheKey);
    }
    // --- end of Cache Management ---

// --- Author Endpoints ---

    async getAuthorInformation(authorId, params = {}) {
        try {
            const response = await this.base.apiR7eClient.get(`authors/search`, { 
                params: { id: authorId, ...params } 
            });
            const authors = response.data.items || [];
            if (authors.length > 0) {
                const author = authors[0];
                // Transform the response to match the expected format
                return {
                    name: author.name || authorId,
                    description: author.description || `Recognyzed author`,
                    email: author.email,
                    email_verified: true,
                    member_since: author.member_since || author.creation_date,
                    avatar_url: author.avatar_url,
                    affiliation: author.affiliation,
                    area_of_interest: author.area_of_interest,
                    orcid: author.orcid,
                    gscholar: author.gscholar,
                    homepage: author.homepage,
                    linkedin: author.linkedin,
                    tags: author.tags,
                    r_index: author.r_index,
                    r_index_5: author.r_index_5,
                    rendering_count: author.rendering_count
                };
            } else {
                throw new Error(`Author ${authorId} not found`);
            }
        } catch (error) {
            console.error("Error fetching author information:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getAuthorCoAuthors(authorId, params = {}) {
        return fake_value(this, 'co_authors', authorId, params);
        // try {
        //     const response = await this.base.apiR7eClient.get(`author/${authorId}/co-authors/`, { params });
        //     return response.data;
        // } catch (error) {
        //     console.error("Error fetching co authors:", error.response ? error.response.data : error.message);
        //     throw error;
        // }
    }

    /**
     * Fetch author's claim contents
     * @param {string} authorId - The author's ID (username)
     * @param {object} params - Optional query params (offset, count)
     * @returns {Promise<object>} Claim contents list
     */
    async getAuthorClaimContents(authorId, params = {}) {
        try {
            const response = await this.base.apiR7eClient.get(`author/${authorId}/claim-contents/`, { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching author claim contents:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    /**
     * Check if URL can be claimed and get publisher contact info
     * @param {string} authorId - The author's ID (username)
     * @param {object} payload - Check data { url: string }
     * @returns {Promise<object>} Check claim result
     */
    async checkClaimContent(authorId, payload) {
        try {
            // console.log("checkClaimContent", `author/${authorId}/claim-contents/check-claim`, authorId, payload);
            const response = await this.base.apiR7eClient.post(`author/${authorId}/claim-contents/check-claim`, payload);
            return response.data;
        } catch (error) {
            console.error("Error checking claim content:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    /**
     * Create new intellectual property claim
     * @param {string} authorId - The author's ID (username)
     * @param {object} payload - Claim data { url: string, is_publisher?: boolean }
     * @returns {Promise<object>} Created claim content
     * @description Sends is_publisher in JSON body as expected by backend API
     */
    async createClaimContent(authorId, payload) {
        try {
            // Send payload with is_publisher in JSON body as expected by backend
            const response = await this.base.apiR7eClient.post(`author/${authorId}/claim-contents/`, payload);
            return response.data;
        } catch (error) {
            console.error("Error creating claim content:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    /**
     * Get specific claim content
     * @param {string} authorId - The author's ID (username)
     * @param {string} claimId - The claim content ID
     * @returns {Promise<object>} Claim content details
     */
    async getClaimContent(authorId, claimId) {
        return fake_value(this, 'claim_content_detail', `${authorId}_${claimId}`, {});

        // try {
        //     const response = await this.base.apiR7eClient.get(`author/${authorId}/claim-content/${claimId}`);
        //     return response.data;
        // } catch (error) {
        //     console.error("Error fetching claim content:", error.response ? error.response.data : error.message);
        //     throw error;
        // }
    }

    /**
     * Get claim request by identifier for current author
     * @param {string} claimId - The claim content ID
     * @returns {Promise<object>} Claim content details
     */
    async getClaimRequest(claimId) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const authorId = this.getUsername();
            const response = await this.base.apiR7eClient.get(`author/${encodeURIComponent(authorId)}/claim-content/${encodeURIComponent(claimId)}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching claim request:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    /**
     * Update claim content
     * @param {string} authorId - The author's ID (username)
     * @param {string} claimId - The claim content ID
     * @param {object} payload - Update data { url?: string, data?: object }
     * @returns {Promise<object>} Updated claim content
     */
    async updateClaimContent(authorId, claimId, payload) {
        return fake_value(this, 'update_claim_content', `${authorId}_${claimId}`, payload);

        // try {
        //     const response = await this.base.apiR7eClient.put(`author/${authorId}/claim-content/${claimId}`, payload);
        //     return response.data;
        // } catch (error) {
        //     console.error("Error updating claim content:", error.response ? error.response.data : error.message);
        //     throw error;
        // }
    }

    /**
     * Delete claim content
     * @param {string} authorId - The author's ID (username)
     * @param {string} claimId - The claim content ID
     * @returns {Promise<object>} Deletion result
     */
    async deleteClaimContent(authorId, claimId) {
        try {
            const response = await this.base.apiR7eClient.delete(`author/${authorId}/claim-content/${claimId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting claim content:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    /**
     * Fetch author content list from stats service via Eiffel proxy
     * 
     * Request flow:
     * 1. Frontend calls: GET {API_URL}/authors/stats/{authorId}/contents
     * 2. Eiffel proxy (r7e_authors_webapi_handler.e) receives request at:
     *    /api/v1/authors/stats/{author_id}/{data} where data="contents"
     * 3. Eiffel proxy forwards to Python stats service:
     *    GET {stats_server_url}/stats/authors/{author_id}/contents
     * 4. Eiffel proxy processes response and extracts pagination fields
     * 5. Returns processed response to frontend
     * 
     * @param {string} authorId - The author's ID (username)
     * @param {object} params - Optional query params (page, page_size)
     * @returns {Promise<object>} Content list with pagination (items, page, page_size, total_count, total_pages)
     */
    async getAuthorContentList(authorId, params = {}) {
        try {
            const response = await this.base.apiR7eClient.get(`authors/stats/${authorId}/contents`, { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching author contents:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    /**
     * Search authors by name
     * @param {string} name - The name to search for
     * @param {object} options - Optional query params
     * @returns {Promise<object>} List of authors
     */
    async searchAuthorsByName(name, options = {}) {
        return this.searchAuthors({ "name": name }, options);
    }

    /**
     * Search authors by name
     * @param {object} fields - The fields to search for (name, email, orcid, ...)
     * @param {object} options - Optional query params
     * @returns {Promise<object>} List of authors
     */
    async searchAuthors(fields, options = {}) {
        // console.log("searchAuthors", fields, options);   
        const params = {}
        for (const [key, value] of Object.entries(fields)) {
            params[key] = value;
        }
        for (const [key, value] of Object.entries(options)) {
            params[key] = value;
        }
        try {
            const response = await this.base.apiR7eClient.get('authors/search',  { params: params });
            return response.data;
        } catch (error) {
            console.error("Error searching authors:", error.response ? error.response.data : error.message);
            throw error;
        }
    }    

    /**
     * Fetch geographic traffic data
     * @param {string} authorId - The author's ID (username)
     * @param {object} params - Query params { start_date, end_date, limit }
     * @returns {Promise<object>} Geographic distribution data
     */
    async getAuthorGeographicData(authorId, params = {}) {
        try {
            // Build query parameters
            const { start_date, end_date, queryParams } = this.prepareParams(params);
            if (!("limit" in queryParams)) {
                queryParams["limit"] = 20;
            }
            
            // Fetch both geographic and city data in parallel
            const [geoResponse, cityResponse] = await Promise.allSettled([
                this.base.apiR7eClient.get(`authors/stats/${authorId}/period/${start_date}/${end_date}/geographic`,
                    { params: queryParams }
                ),
                this.getAuthorCityData(authorId, params)
            ]);
            
            // Handle geographic response (required)
            if (geoResponse.status === 'rejected') {
                throw geoResponse.reason;
            }
            
            const geoData = geoResponse.value.data && geoResponse.value.data.status === "success" && geoResponse.value.data.items
                ? geoResponse.value.data.items
                : geoResponse.value.data;
            
            // Handle city response (optional - may fail gracefully)
            const cityData = cityResponse.status === 'fulfilled' ? cityResponse.value : null;
            
            // Log city data for debugging
            if (cityResponse.status === 'rejected') {
                console.warn("City data request failed:", cityResponse.reason);
            } else if (cityData) {
                console.log("City data received:", {
                    hasCities: !!(cityData.cities),
                    citiesLength: cityData.cities ? cityData.cities.length : 0,
                    hasError: !!cityData.error,
                    error: cityData.error
                });
            }
            
            // Transform backend response with city data merged in
            return this._transformGeographicData(geoData, cityData);
        } catch (error) {
            console.error("Error fetching geographic data:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    /**
     * Fetch city-level geographic data
     * @param {string} authorId - The author's ID (username)
     * @param {object} params - Query params { start_date, end_date, limit }
     * @returns {Promise<object>} City data or empty object with error
     */
    async getAuthorCityData(authorId, params = {}) {
        try {
            const { start_date, end_date, queryParams } = this.prepareParams(params);
            if (!("limit" in queryParams)) {
                queryParams["limit"] = 100; // Higher limit for cities
            }
            
            const response = await this.base.apiR7eClient.get(`authors/stats/${authorId}/period/${start_date}/${end_date}/cities`,
                { params: queryParams }
            );
            
            // Handle response format: { status: "success", items: {...} }
            const data = response.data && response.data.status === "success" && response.data.items
                ? response.data.items
                : response.data;
            
            // Log for debugging
            if (!data || !data.cities || !Array.isArray(data.cities) || data.cities.length === 0) {
                console.warn("City data is empty or invalid:", {
                    hasData: !!data,
                    hasCities: !!(data && data.cities),
                    isArray: !!(data && data.cities && Array.isArray(data.cities)),
                    citiesLength: data && data.cities ? data.cities.length : 0,
                    error: data && data.error,
                    fullResponse: data
                });
            }
            
            return data;
        } catch (error) {
            console.error("Error fetching city data:", {
                message: error.message,
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data,
                url: error.config?.url
            });
            // Return empty data instead of throwing - city data is optional
            return {
                cities: [],
                error: error.response?.data?.error || error.message || "City data not available"
            };
        }
    }

    /**
     * Transform backend geographic data to frontend format
     * @private
     * @param {object} backendData - Data from backend API
     * @param {object} cityData - Optional city data from backend API
     * @returns {object} Transformed data matching frontend expectations
     */
    _transformGeographicData(backendData, cityData = null) {
        // Transform countries array: rename 'visits' to 'count'
        const countries = (backendData.countries || []).map(country => ({
            country: country.country,
            country_code: country.country_code,
            count: country.visits,  // Map visits → count
            percentage: country.percentage,
            visits: country.visits,
            page_views: country.page_views,
            unique_visitors: country.unique_visitors,
            city_breakdown: []  // Will be populated below if city data available
        }));
        
        // Group cities by country if city data is available
        // Check for city data - ignore if it has an error or empty cities array
        if (cityData && !cityData.error && cityData.cities && Array.isArray(cityData.cities) && cityData.cities.length > 0) {
            const citiesByCountry = {};
            
            // Group cities by country_code
            cityData.cities.forEach(city => {
                const countryCode = city.country_code;
                if (!citiesByCountry[countryCode]) {
                    citiesByCountry[countryCode] = [];
                }
                citiesByCountry[countryCode].push({
                    city: city.city,
                    count: city.visits,
                    percentage: city.percentage || 0,
                    visits: city.visits,
                    page_views: city.page_views,
                    unique_visitors: city.unique_visitors,
                    latitude: city.latitude,
                    longitude: city.longitude
                });
            });
            
            // Populate city_breakdown for each country
            countries.forEach(country => {
                if (citiesByCountry[country.country_code]) {
                    country.city_breakdown = citiesByCountry[country.country_code];
                }
            });
        }
        
        // Transform regional_breakdown to continent_summary
        const continent_summary = [];
        if (backendData.regional_breakdown) {
            for (const [continentName, data] of Object.entries(backendData.regional_breakdown)) {
                continent_summary.push({
                    continent: continentName,
                    count: data.total_visits,
                    percentage: data.percentage
                });
            }
        }
        
        // Time zone distribution - not available from backend yet
        // Use empty array for now
        const time_zone_distribution = [];
        
        return {
            countries,
            continent_summary,
            time_zone_distribution,
            // Include original backend data for reference
            summary: backendData.summary,
            insights: backendData.insights,
            period: backendData.period
        };
    }

    /**
     * Fetch LLM referral analysis data
     * @param {string} authorId - The author's ID (username)
     * @param {object} params - Query params { start_date, end_date }
     * @returns {Promise<object>} LLM referral analysis data
     */
    async getAuthorLLMReferrals(authorId, params = {}) {
        try {
            const { start_date, end_date, queryParams } = this.prepareParams(params);
            if (!("limit" in queryParams)) {
                queryParams["limit"] = 10;
            }

            const response = await this.base.apiR7eClient.get(`authors/stats/${authorId}/period/${start_date}/${end_date}/llm-referrals`,
                { params: queryParams }
            );
            // Handle new response format: { status: "success", items: {...} }
            const data = response.data && response.data.status === "success" && response.data.items
                ? response.data.items
                : response.data;
            return this._transformLLMReferralsData(data);
        } catch (error) {
            console.error("Error fetching LLM referral data:", error);
            throw error;
        }
    }

    /**
     * Transform LLM referrals backend data to frontend format
     * @param {object} backendData - Backend response data
     * @returns {object} Transformed data for frontend
     */
    _transformLLMReferralsData(backendData) {
        // Transform llm_referrals array to platforms array
        const platforms = (backendData.llm_referrals || []).map(ref => ({
            name: ref.llm_platform,
            referrals: ref.visits,
            traffic_generated: ref.unique_sessions,
            percentage: 0, // Calculate after
            conversion_rate: ref.conversion_rate
        }));
        
        // Calculate percentages
        const totalReferrals = platforms.reduce((sum, p) => sum + p.referrals, 0);
        platforms.forEach(p => {
            p.percentage = totalReferrals > 0 
                ? parseFloat(((p.referrals / totalReferrals) * 100).toFixed(1))
                : 0;
        });
        
        // Build content_by_platform
        const content_by_platform = {};
        (backendData.llm_referrals || []).forEach(ref => {
            content_by_platform[ref.llm_platform] = (ref.content_referred || []).map(c => ({
                content_id: c.content_id,
                title: c.title || c.content_id,
                url: c.content_id, // Use content_id as URL for now
                referrals: c.visits,
                traffic_generated: c.visits,
                citation_context: "", // Not available from backend
                context_type: "Technical Discussion",
                impact_score: this._calculateImpactScore(c.visits, ref.visits)
            }));
        });
        
        // Build trends (mock for now as backend doesn't provide time series)
        const trends = [];
        
        // Build citation metrics from summary
        const summary = backendData.summary || {};
        const totalTraffic = summary.total_visits || summary.total_unique_sessions || 0;
        const citation_metrics = {
            total_citations: totalTraffic,
            accuracy_rate: summary.citation_accuracy_rate || 0, // Use backend value if available, otherwise 0
            attributed_traffic: summary.total_unique_sessions || 0,
            avg_citation_depth: summary.avg_citation_depth || 0 // Use backend value if available, otherwise 0
        };
        
        // Build attribution (use backend values if available, otherwise 0)
        const directReferrals = summary.total_unique_sessions || 0;
        const indirectCitations = summary.indirect_citations || 0;
        const seoBoost = summary.seo_boost || 0;
        const socialMentions = summary.social_mentions || 0;
        
        // Calculate total for percentage calculations
        const totalAttribution = directReferrals + indirectCitations + seoBoost + socialMentions;
        
        // Calculate percentages based on actual data
        const attribution = {
            direct_referrals: directReferrals,
            direct_percentage: totalAttribution > 0 ? parseFloat(((directReferrals / totalAttribution) * 100).toFixed(1)) : 0.0,
            indirect_citations: indirectCitations,
            indirect_percentage: totalAttribution > 0 ? parseFloat(((indirectCitations / totalAttribution) * 100).toFixed(1)) : 0.0,
            seo_boost: seoBoost,
            seo_percentage: totalAttribution > 0 ? parseFloat(((seoBoost / totalAttribution) * 100).toFixed(1)) : 0.0,
            social_mentions: socialMentions,
            social_percentage: totalAttribution > 0 ? parseFloat(((socialMentions / totalAttribution) * 100).toFixed(1)) : 0.0
        };
        
        // Build behavior patterns (use summary data or defaults)
        const behavior_patterns = {
            avg_session_duration: Math.round(summary.avg_session_duration || 0),
            bounce_rate: 30.0, // Not available
            pages_per_session: 2.5, // Not available
            deep_reading_rate: 45.0,
            quick_scan_rate: 35.0,
            social_sharing_rate: 20.0,
            peak_hours: "9AM-5PM",
            peak_days: "Mon-Fri",
            avg_time_on_page: Math.round(summary.avg_session_duration || 0),
            return_visitor_rate: 30.0,
            avg_visits_per_user: 2.0,
            avg_days_between_visits: 10
        };
        
        return {
            platforms,
            citation_metrics,
            content_by_platform,
            trends,
            attribution,
            behavior_patterns
        };
    }

    /**
     * Calculate impact score based on content visits vs platform total
     * @param {number} contentVisits - Visits to specific content
     * @param {number} platformTotalVisits - Total visits to platform
     * @returns {number} Impact score 0-100
     */
    _calculateImpactScore(contentVisits, platformTotalVisits) {
        if (platformTotalVisits === 0) return 50;
        const percentage = (contentVisits / platformTotalVisits) * 100;
        // Map 0-100% to impact score 0-100
        return Math.min(100, Math.round(percentage * 1.5));
    }

    /* Global stats functions */

    /**
     * Fetch author stats overview from stats service
     * @param {string} authorId - The author's ID (username)
     * @param {object} params - Optional query params (start_date, end_date)
     * @returns {Promise<object>} Stats overview data
     */
    async getAuthorStatsOverview(authorId, params = {}) {
        try {
            const { start_date, end_date, queryParams } = this.prepareParams(params);

            const response = await this.base.apiR7eClient.get(`authors/stats/${authorId}/period/${start_date}/${end_date}/overview`, { params: queryParams });
            // Handle new response format: { status: "success", items: {...} }
            if (response.data && response.data.status === "success" && response.data.items) {
                return response.data.items;
            }
            // Backward compatibility: return data directly if not wrapped
            return response.data;
        } catch (error) {
            console.error("Error fetching author stats overview:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    /**
     * Fetch author stats distribution from stats service
     * @param {string} authorId - The author's ID (username)
     * @param {object} params - Optional query params (start_date, end_date)
     * @returns {Promise<object>} Stats distribution data
     */
    async getAuthorStatsDistribution(authorId, params = {}) {
        try {
            const { start_date, end_date, queryParams } = this.prepareParams(params);

            const response = await this.base.apiR7eClient.get(`authors/stats/${authorId}/period/${start_date}/${end_date}/distribution`, { params: queryParams });
            // Handle new response format: { status: "success", items: {...} }
            if (response.data && response.data.status === "success" && response.data.items) {
                return response.data.items;
            }
            // Backward compatibility: return data directly if not wrapped
            return response.data;
        } catch (error) {
            console.error("Error fetching author stats distribution:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    /**
     * Fetch author traffic trends over time from stats service
     * @param {string} authorId - The author's ID (username)
     * @param {object} params - Optional query params (start_date, end_date, granularity)
     * @returns {Promise<object>} Trends data including summary, insights, and per-period series
     */
    async getAuthorTrends(authorId, params = {}) {
        try {
            const { start_date, end_date, queryParams } = this.prepareParams(params);

            const response = await this.base.apiR7eClient.get(`authors/stats/${authorId}/period/${start_date}/${end_date}/trends`, { params: queryParams });
            // Handle new response format: { status: "success", items: {...} }
            if (response.data && response.data.status === "success" && response.data.items) {
                return response.data.items;
            }
            // Backward compatibility: return data directly if not wrapped
            return response.data;
        } catch (error) {
            console.error("Error fetching author trends:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    /**
     * Fetch AI-Index data for an author from stats service
     * @param {string} authorId - The author's ID (username)
     * @param {object} params - Optional query params (start_date, end_date)
     * @returns {Promise<object>} AI-Index data including summary, top_contents, yearly, and config
     */
    async getAuthorRIndex(authorId, params = {}) {
        try {
            const { start_date, end_date, queryParams } = this.prepareParams(params);
            const response = await this.base.apiR7eClient.get(`authors/stats/${authorId}/period/${start_date}/${end_date}/r-index`, { params: queryParams });
            // Handle new response format: { status: "success", items: {...} }
            if (response.data && response.data.status === "success" && response.data.items) {
                return response.data.items;
            }
            // Backward compatibility: return data directly if not wrapped
            return response.data;
        } catch (error) {
            console.error("Error fetching AI-Index data:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    
    /**
     * Fetch global traffic data over time (for stacked area chart)
     * @param {string} authorId - The author's ID (username)
     * @param {object} params - Query params { start_date, end_date, granularity }
     * @returns {Promise<object>} Global traffic data over time
     *  
     * TODO 
     * implement this function
     */
    async getAuthorGlobalTraffic(authorId, params = {}) {
        return fake_value(this, 'global_traffic', authorId, params);
        // try {
        //     const response = await this.base.apiR7eClient.get(`author/${authorId}/traffic/global/`, { params });
        //     return response.data;
        // } catch (error) {
        //     console.error("Error fetching global traffic:", error.response ? error.response.data : error.message);
        //     throw error;
        // }
    }    


    /* Content stats functions */
    /* TODO: implement these functions */

    /**
     * Fetch content information
     * @param {string} authorId - The author's ID
     * @param {string} contentId - The content's ID
     * @param {object} params - Optional query params
     * @returns {Promise<object>} Content information
     */
    async getContentInformation(authorId, contentId, params = {}) {
        return fake_value(this, 'content_info', `${authorId}_${contentId}`, params);
        // try {
        //     const response = await this.base.apiR7eClient.get(`author/${authorId}/content/${contentId}/`, { params });
        //     return response.data;
        // } catch (error) {
        //     console.error("Error fetching content information:", error.response ? error.response.data : error.message);
        //     throw error;
        // }
    }

    /**
     * Fetch content traffic overview with comprehensive metrics
     * @param {string} authorId - The author's ID
     * @param {string} contentId - The content's ID
     * @param {object} params - Query params { start_date, end_date }
     * @returns {Promise<object>} Content traffic overview data
     */
    async getContentTrafficOverview(authorId, contentId, params = {}) {
        return fake_value(this, 'content_traffic_overview', `${authorId}_${contentId}`, params);
        // try {
        //     const response = await this.base.apiR7eClient.get(`author/${authorId}/content/${contentId}/traffic/overview/`, { params });
        //     return response.data;
        // } catch (error) {
        //     console.error("Error fetching content traffic overview:", error.response ? error.response.data : error.message);
        //     throw error;
        // }
    }

    /**
     * Fetch content agent types breakdown
     * @param {string} authorId - The author's ID
     * @param {string} contentId - The content's ID
     * @param {object} params - Query params { start_date, end_date }
     * @returns {Promise<object>} Content agent types data
     */
    async getContentAgentTypes(authorId, contentId, params = {}) {
        return fake_value(this, 'content_agent_types', `${authorId}_${contentId}`, params);
        // try {
        //     const response = await this.base.apiR7eClient.get(`author/${authorId}/content/${contentId}/traffic/agent-types/`, { params });
        //     return response.data;
        // } catch (error) {
        //     console.error("Error fetching content agent types:", error.response ? error.response.data : error.message);
        //     throw error;
        // }
    }

    /**
     * Fetch content geographic distribution
     * @param {string} authorId - The author's ID
     * @param {string} contentId - The content's ID
     * @param {object} params - Query params { start_date, end_date }
     * @returns {Promise<object>} Content geographic data
     */
    async getContentGeographicData(authorId, contentId, params = {}) {
        return fake_value(this, 'content_geographic', `${authorId}_${contentId}`, params);
        // try {
        //     const response = await this.base.apiR7eClient.get(`author/${authorId}/content/${contentId}/traffic/geographic/`, { params });
        //     return response.data;
        // } catch (error) {
        //     console.error("Error fetching content geographic data:", error.response ? error.response.data : error.message);
        //     throw error;
        // }
    }

    /**
     * Fetch content LLM referral analysis
     * @param {string} authorId - The author's ID
     * @param {string} contentId - The content's ID
     * @param {object} params - Query params { start_date, end_date }
     * @returns {Promise<object>} Content LLM referral data
     */
    async getContentLLMReferrals(authorId, contentId, params = {}) {
        return fake_value(this, 'content_llm_referrals', `${authorId}_${contentId}`, params);
        // try {
        //     const response = await this.base.apiR7eClient.get(`author/${authorId}/content/${contentId}/traffic/llm-referrals/`, { params });
        //     return response.data;
        // } catch (error) {
        //     console.error("Error fetching content LLM referral data:", error.response ? error.response.data : error.message);
        //     throw error;
        // }
    }

    /**
     * Fetch content global traffic data over time (for stacked area chart)
     * @param {string} authorId - The author's ID
     * @param {string} contentId - The content's ID
     * @param {object} params - Query params { start_date, end_date, granularity }
     * @returns {Promise<object>} Content global traffic data over time
     */
    async getContentGlobalTraffic(authorId, contentId, params = {}) {
        return fake_value(this, 'content_global_traffic', `${authorId}_${contentId}`, params);
        // try {
        //     const response = await this.base.apiR7eClient.get(`author/${authorId}/content/${contentId}/traffic/global/`, { params });
        //     return response.data;
        // } catch (error) {
        //     console.error("Error fetching content global traffic:", error.response ? error.response.data : error.message);
        //     throw error;
        // }
    }

    /**
     * Fetch content traffic date ranges
     * @param {string} authorId - The author's ID
     * @param {string} contentId - The content's ID
     * @returns {Promise<object>} Available date ranges for content traffic
     */
    async getContentTrafficDateRanges(authorId, contentId) {
        return fake_value(this, 'content_traffic_date_ranges', `${authorId}_${contentId}`, {});
        // try {
        //     const response = await this.base.apiR7eClient.get(`author/${authorId}/content/${contentId}/traffic/date-ranges/`);
        //     return response.data;
        // } catch (error) {
        //     console.error("Error fetching content traffic date ranges:", error.response ? error.response.data : error.message);
        //     throw error;
        // }
    }

    /* Helper functions */

    prepareParams(params) {
        /* Prepare start_date, end_date and queryParams */
        const start_date = params.start_date || params.start;
        const end_date = params.end_date || params.end;
        const queryParams = {};
        for (const [key, value] of Object.entries(params)) {
            if (key !== 'start_date' && key !== 'end_date') {
                queryParams[key] = value;
            }
        }
        return {
            start_date: start_date,
            end_date: end_date,
            queryParams: queryParams
        };
    }

}

export {R7eAccountTypeError, R7E_AuthorApplication, r7eBaseApp, DEBUG_MODE };
export default {  ...R7eAccountTypeError, R7E_AuthorApplication, r7eBaseApp, DEBUG_MODE }
